<div class="sms-price-view">
    <div class="sms-price-view-title">
        {{title | translate}}
    </div>

    <div class="sms-price-view-description alert-primary" *ngIf="description!=null && description!=''">
        {{description | translate}}
    </div>

    <div class="sms-language-col tw-pl-3  sms-language-fa">
        <div class="price-holder">
            <span class="price-language">

                FA
            </span>
            <span class="price-label">
                {{ persianPrice.toLocaleString()}}
            </span>
            <span class="price-currency">
                {{ currency | translate }}
            </span>
        </div>
    </div>
    <div class="sms-language-col tw-pr-2">
        <div class="price-holder">
            <span class="price-language">
                EN
            </span>
            <span class="price-label">
                {{ englishPrice.toLocaleString()}}
            </span>
            <span class="price-currency">
                {{ currency | translate }}
            </span>
        </div>
    </div>

</div>